import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FlameIcon, ChevronDownIcon } from 'lucide-react';
export const Header: React.FC = () => {
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const navigate = useNavigate();
  const handleResourceClick = (sectionId: string) => {
    navigate('/resources');
    setIsResourcesOpen(false);
    // Scroll to section after navigation
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };
  return <header className="bg-background-light py-4 px-6 flex justify-between items-center shadow-lg" data-id="element-54">
      <Link to="/" className="flex items-center gap-2 text-primary font-bold text-2xl" data-id="element-55">
        <FlameIcon className="h-8 w-8" data-id="element-56" />
        <span data-id="element-57">IBD Rant</span>
      </Link>
      <nav className="flex gap-4 items-center" data-id="element-58">
        <Link to="/" className="text-text-primary hover:text-primary transition-colors" data-id="element-59">
          Home
        </Link>
        <Link to="/hall-of-rage" className="text-text-primary hover:text-primary transition-colors" data-id="element-60">
          Hall of Rage
        </Link>
        <div className="relative" onMouseEnter={() => setIsResourcesOpen(true)} onMouseLeave={() => setIsResourcesOpen(false)} data-id="element-61">
          <Link to="/resources" className="text-text-primary hover:text-primary transition-colors flex items-center gap-1" data-id="element-62">
            Resources
            <ChevronDownIcon className="h-4 w-4" data-id="element-63" />
          </Link>
          {isResourcesOpen && <div className="absolute top-full left-0 mt-2 bg-background-light border-2 border-gray-800 rounded-lg shadow-xl min-w-[200px] py-2 z-50" data-id="element-64">
              <button onClick={() => handleResourceClick('shopping-section')} className="w-full text-left px-4 py-2 text-text-primary hover:bg-background hover:text-primary transition-colors" data-id="element-65">
                Shopping
              </button>
              <button onClick={() => handleResourceClick('research-section')} className="w-full text-left px-4 py-2 text-text-primary hover:bg-background hover:text-primary transition-colors" data-id="element-66">
                Research & Studies
              </button>
              <button onClick={() => handleResourceClick('blog-section')} className="w-full text-left px-4 py-2 text-text-primary hover:bg-background hover:text-primary transition-colors" data-id="element-67">
                Blog Posts & Articles
              </button>
            </div>}
        </div>
      </nav>
    </header>;
};